import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Box, Container } from '@mui/material';
import { SidebarProvider } from './SidebarContext';
import { Topbar } from './Topbar';
import { Sidebar } from './Sidebar';
import { LAYOUT_BORDER_OFFSET, SIDE_NAV_WIDTH } from './constants';
const LayoutRoot = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    maxWidth: '100%',
    paddingLeft: 0,
    [theme.breakpoints.up('lg')]: {
        paddingLeft: SIDE_NAV_WIDTH,
    },
}));
const borderOffset = LAYOUT_BORDER_OFFSET;
const LayoutContainer = styled(Box)({
    paddingTop: borderOffset,
    paddingBottom: borderOffset,
    flex: '1 1 auto',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    minHeight: `calc(100vh - ${borderOffset * 2}px)`,
    display: 'flex',
});
function SidebarLayoutInner({ children, entries, logo, appName, pageDescription, explanationVideo, resetPageData, userInitial, renderAccountPopover, rightSlot, }) {
    return (_jsxs(_Fragment, { children: [_jsx(Topbar, { pageDescription: pageDescription, explanationVideo: explanationVideo, resetPageData: resetPageData, userInitial: userInitial, renderAccountPopover: renderAccountPopover, rightSlot: rightSlot }), _jsx(Sidebar, { entries: entries, logo: logo, appName: appName }), _jsx(LayoutRoot, { children: _jsx(LayoutContainer, { sx: { mt: `${borderOffset}px` }, children: _jsx(Container, { maxWidth: false, disableGutters: true, sx: { px: { xs: 2, sm: 4, lg: 8 } }, children: children }) }) })] }));
}
export function SidebarLayout(props) {
    return (_jsx(SidebarProvider, { children: _jsx(SidebarLayoutInner, { ...props }) }));
}
